import { useEffect, type ReactElement } from "react";
import css from "./dashboard.module.css";
import { DASH_HELP, type HelpSwatch } from "./dashHelpData";

/**
 * Объяснитель экрана «Дашборд» ОО (07.09, владелец): по «?» в строке сводки —
 * полный список того, что значат кнопки, цифры, рамки и цвета на этом экране.
 * Содержимое — dashHelpData.ts (разделы сверху вниз по экрану). Легенды внутри
 * карточек игр НЕ рисуем — только здесь.
 */
const SW: Record<HelpSwatch, string> = {
  red: css.swRed ?? "", gold: css.swGold ?? "", green: css.swGreen ?? "", cyan: css.swCyan ?? "", pink: css.swPink ?? "",
  purple: css.swPurple ?? "", mc: css.swMc ?? "", blue: css.swBlue ?? "", lime: css.swLime ?? "", orange: css.swOrange ?? "", grey: css.swGrey ?? "",
};

export function DashHelp({ onClose }: { onClose: () => void }): ReactElement {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className={css.mvOverlay} role="dialog" aria-modal="true" aria-label="Что здесь что значит" onClick={onClose}>
      <div className={`${css.mvFrame} ${css.helpFrame}`} onClick={(e) => e.stopPropagation()}>
        <div className={css.mvHead}>
          <span className={css.mvTitle}>Что здесь что значит</span>
          <button type="button" className={css.mvClose} onClick={onClose} aria-label="Закрыть">✕</button>
        </div>
        <div className={css.helpBody}>
          {DASH_HELP.map((sec) => (
            <section key={sec.title} className={css.helpSec}>
              <h4 className={css.helpSecT}>{sec.title}</h4>
              {sec.items.map((it) => (
                <div key={it.term} className={css.helpItem}>
                  {it.swatch ? <i className={`${css.helpSw} ${SW[it.swatch]}`} aria-hidden="true" /> : null}
                  <b>{it.term}</b> — {it.text}
                </div>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
